<template lang="pug">
  r-form(
    ref='form'
    reset-text='restablecer'
    submit-text='guardar'
    title='editar sucursal'
    v-bind='formProps'
    v-model='gBranchOffice'
    @reset='submitReset'
    @submit='submitCreate'
    )
</template>

<script>
  //
  import { RForm } from '@/components/reusable_components/next'
  import TranslatorService from '@/services/translator'
  //
  import GBranchOfficeFields from '@/views/General/GBranchOffice/GBranchOfficeFields'
  import GBranchOfficeModel from '@/models/General/GBranchOffice'
  //
  export default {
    components: {
      RForm,
    },
    computed: {
      formProps() {
        return {
          fields: GBranchOfficeFields,
        }
      }
    },
    data() {
      return {
        gBranchOffice: new GBranchOfficeModel({
          address: '',
          branch_office_sii: '',
          email: '',
          g_commune_id: '',
          name: '',
          phone: '',
        }),
      }
    },
    methods: {
      getGBranchOffice() {
        return GBranchOfficeModel.find(this.$route.params.id)
      },
      setGBranchOffice(gBranchOffice) {
        this.gBranchOffice = gBranchOffice.reset()
      },
      showCreateError(event) {
        this.$toast.error(TranslatorService(GBranchOfficeModel, event.response.data))
      },
      showCreateSuccess() {
        this.$toast.success('Sucursal creada exitosamente')
      },
      submitCreate() {
        return this
          .toWait(true)
          .then(this.toUpdate)
          .then(this.toWait)
      },
      submitReset() {
        this
          .toWait(true)
          .then(this.getGBranchOffice)
          .then(this.setGBranchOffice)
          .then(this.toWait)
      },
      toUpdate() {
        return this
          .gBranchOffice
          .toUpdate()
          .save()
          .then(this.showCreateSuccess)
          .then(this.toRedirect)
          .catch(this.showCreateError)
      },
      toRedirect() {
        this.$router.push({ name: 'g-branch-office-list' })
      },
      toWait(value = false) {
        return this.$refs.form.setWait(value)
      },
    },
    created() {
      this.setTitle('Editar sucursal')
    },
    mounted() {
      this.submitReset()
    }
  }
</script>